import { render, staticRenderFns } from "./MessageSnackBar.vue?vue&type=template&id=03718958&"
import script from "./MessageSnackBar.vue?vue&type=script&lang=js&"
export * from "./MessageSnackBar.vue?vue&type=script&lang=js&"
import style0 from "./MessageSnackBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports